import {
  Box,
  Button,
  Typography,
} from '@mui/material';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

import { Helmet } from 'react-helmet-async';

import FormStyle from '../FormStyle';

function SentEmailWithSuccess(
  {
    setIsChangingEmail,
    setHasSentMail,
  }: {
    setIsChangingEmail: (isChangingEmail: boolean) => void,
    setHasSentMail: (hasSentMail: boolean) => void,
  },
) {
  const handleReturn = () => {
    setIsChangingEmail(false);
    setHasSentMail(false);
  };

  return (
    <>
      <Helmet>
        <title>Change email address</title>
      </Helmet>
      <Box className="container-fluid my-2">
        <Box
          sx={FormStyle.previewHeader}
        >
          <h1 className="text-bold my-3">
            Change email address
          </h1>

          <Box
            sx={{
              border: '2px solid #dc3545',
              padding: '0.5rem',
            }}
          >
            <Typography
              fontSize={12}
              color="#dc3545"
            >
              <FontAwesomeIcon icon={faCircleExclamation} className="mx-2" />
              <span>Email change is not yet complete</span>
            </Typography>
          </Box>
        </Box>

        <Box className="card text-center">
          <Box className="card-body">
            <h3 className="text-bold">
              Verification email has been sent
            </h3>
            <br />
            <p className="text-start">
              A verification URL has been sent to the email address you entered.
            </p>
            <br />
            <p className="text-start">
              If you don&apos;t receive it after a while, it may be in your spam folder or you may have entered an incorrect email address.
            </p>
            <br />
            <Button
              onClick={handleReturn}
              variant="outlined"
              className="btn-outline-secondary"
            >
              Back
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default SentEmailWithSuccess;
